import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=f31ae7b4&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f31ae7b4')) {
      api.createRecord('f31ae7b4', component.options)
    } else {
      api.reload('f31ae7b4', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=f31ae7b4&", function () {
      api.rerender('f31ae7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-277ZPZNvk99Jx/JS/childrenage.vue"
export default component.exports